<template>
  <div
    v-if="visibleMembers.length > 0"
    class="mx-auto mt-4 flex w-full max-w-4xl flex-row justify-end px-2"
  >
    <div class="bg-primary-container rounded-large mb-2 p-3">
      <div class="text-on-primary-container mb-1.5 flex flex-row items-center gap-1">
        <BaseIcon size="18">visibility</BaseIcon>
        <h3 class="text-title-small">Wer sieht das Feedback?</h3>
      </div>
      <div class="divide-outline -mx-3 flex flex-row divide-x [&>div]:px-3">
        <div
          v-for="member in visibleMembers"
          :key="member.member.id"
          class="flex flex-row items-center"
        >
          <BaseMemberAvatar class="mr-2" :member="member.member" size="32" />
          <div class="flex flex-col">
            <span class="text-title-small">{{ memberAbbreviatedName(member.member) }}</span>
            <span class="text-label-small text-on-surface-variant -mt-0.5">{{ member.type }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import BaseMemberAvatar from '@/core/components/base/avatar/BaseMemberAvatar.vue'
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import type { Member } from '@/core/models/member/member'
  import { memberAbbreviatedName } from '@/core/models/member/member-name'
  import { useUserStore } from '@/stores/user.store'
  import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'

  interface Props {
    receiver: Member
    sharedFeedback?: {
      members: ReadonlyArray<Member>
    }
    supervisors?: ReadonlyArray<Member>
  }

  const props = defineProps<Props>()

  const { user } = useUserStore()

  const { t } = useI18n()

  const visibleMembers = computed(() => {
    const members: { member: Member; type: string }[] = []
    if (props.receiver.id != user.id) {
      members.push({ member: props.receiver, type: t('common.receiver') })
    }

    const sharedFeedbackMembers = [
      ...(props.sharedFeedback?.members ?? []),
      ...(props.supervisors ?? []),
    ]

    const actualSharedFeedbackMembers = [
      ...new Map(sharedFeedbackMembers.map((member) => [member.id, member])).values(),
    ]

    actualSharedFeedbackMembers.forEach((member) => {
      members.push({ member, type: t('common.coach') })
    })

    return members
  })
</script>
